<div class="timepicker" [ngClass]="{ disabled: disabled }">
  <div class="inputwrapper" (click)="toggleDialog()" [ngClass]="{ rtl: rtl }">
    <input class="inputtext" type="text" [value]="timeString" [placeholder]="placeHolder" readonly />

    <span class="inputwrapper__icon"> <span class="cmx-icon-clock"></span> </span>
  </div>

  <div class="dialog" *ngIf="isDialogOpen">
    <div class="dialog__wrapper">
      <div class="dialog__hours">
        <div class="timepicker__control">
          <span class="arrow cmx-icon-straight-arrow-up" (click)="hourChange(1)"></span>
        </div>
        <div class="timepicker__text">
          <input
            type="text"
            [value]="hours"
            class="inputtext"
            (change)="keyboardChange('h', $event.target)"
            maxlength="2"
            [readonly]="!writable"
          />
        </div>
        <div class="timepicker__control">
          <span class="arrow cmx-icon-straight-arrow-down" (click)="hourChange(-1)"></span>
        </div>
      </div>
      <div class="dialog__divider"><span class="inputtext">:</span></div>
      <div class="dialog__minutes">
        <div class="timepicker__control">
          <span class="arrow cmx-icon-straight-arrow-up" (click)="minuteChange(1)"></span>
        </div>
        <div class="timepicker__text">
          <input
            type="text"
            [value]="minutes"
            class="inputtext"
            (change)="keyboardChange('m', $event.target)"
            maxlength="2"
            [readonly]="!writable"
          />
        </div>
        <div class="timepicker__control">
          <span class="arrow cmx-icon-straight-arrow-down" (click)="minuteChange(-1)"></span>
        </div>
      </div>
      <div class="dialog__meridian" *ngIf="hourFormat === '12'">
        <div class="timepicker__control">
          <span class="arrow cmx-icon-straight-arrow-up" (click)="toggleMeridian()"></span>
        </div>
        <div class="timepicker__text">
          <input type="text" [value]="meridian" (click)="toggleMeridian()" class="inputtext" readonly />
        </div>
        <div class="timepicker__control">
          <span class="arrow cmx-icon-straight-arrow-down" (click)="toggleMeridian()"></span>
        </div>
      </div>
    </div>
  </div>
</div>
